import { Inject, Injectable } from "@angular/core";
import { loadStripe } from "@stripe/stripe-js/pure";
import type { Stripe } from "@stripe/stripe-js";
import { IDeveloperBillingRestClient } from "../../rest-clients/billing/i-developer-billing-rest.client";
import { developerBillingRestClientInjectionToken } from "../../rest-clients/billing/developer-billing-rest-client-injection-token";

@Injectable({ providedIn: "root" })
export class StripeService {
	private _stripe: Stripe | null = null;
	private _loadPromise: Promise<Stripe | null> | null = null;

	constructor(
		@Inject(developerBillingRestClientInjectionToken) private readonly _billingRestClient: IDeveloperBillingRestClient
	) {}

	async getStripe(): Promise<Stripe | null> {
		if (this._stripe) return this._stripe;
		if (this._loadPromise) return this._loadPromise;

		this._loadPromise = this.initStripe();
		this._stripe = await this._loadPromise;
		return this._stripe;
	}

	private async initStripe(): Promise<Stripe | null> {
		const config = await this._billingRestClient.getBillingConfig();

		return loadStripe(config.publishableKey, {
			locale: "auto"
		});
	}
}
